<script setup>
import {Link} from '@inertiajs/vue3';
import MaskIcon from "@/Components/MaskIcon.vue";
import TelegramLogo from "@/Components/Icons/TelegramLogo.vue";
import {route} from "ziggy-js";
import {getLang, tgUrl} from "@/constants.js";
import {ref} from "vue";
import {activeCurrency} from "@/helper.js";

const lang = getLang();
const currency = ref(activeCurrency)

</script>

<template>
    <div class="bg-white dark:bg-dark-blue pt-6 w-full">
        <div class="max-w-7xl mx-auto">
            <div class="px-3">
                <div class="flex justify-between items-center flex-wrap">
                    <div class="flex gap-16 items-center">
                        <MaskIcon src="/assets/icons/ak-logo-small.svg" class="w-[100px] h-[16px] bg-deep-blue dark:bg-slate-300"/>
                    </div>
                    <div class="flex justify-between items-center">
                        <a class="hover:text-deep-blue dark:text-slate-400 text-slate-500 transition-colors" href="https://vk.com/anykod"
                           target="_blank">
                            <ion-icon name="logo-vk" class="text-2xl hover:text-slate-200 text-slate-400 transition-colors align-middle" style="width: 24px; height: 24px"></ion-icon>
                        </a>
                        <a class="ml-3 group" :href="tgUrl" target="_blank">
                            <TelegramLogo color-plain="fill-deep-blue group-hover:fill-slate-200" class="w-[24px] h-[24px] group-hover:fill-deep-blue dark:text-slate-300 transition-colors"/>
                        </a>
                    </div>
                </div>
            </div>
            <div class="px-3 flex flex-wrap gap-x-6 mt-5">
                <Link class="font-condensed text-slate-600 dark:text-gray-500 hover:text-black dark:hover:text-slate-200 transition-colors font-medium text-sm"
                      :href="route('pages.show', {slug:'privacy-policy'})">{{ $t('Privacy Policy') }}
                </Link>
                <Link class="font-condensed text-slate-600 dark:text-gray-500 hover:text-black dark:hover:text-slate-200  transition-colors font-medium text-sm"
                      :href="route('pages.show', {slug:'cookies-policy'})">{{ $t('Cookie Policy') }}
                </Link>
                <Link class="font-condensed text-slate-600 dark:text-gray-500 hover:text-black dark:hover:text-slate-200  transition-colors font-medium text-sm"
                      :href="route('pages.show', {slug:'terms-of-use'})">{{ $t('Terms of Use') }}
                </Link>
            </div>
            <div class="px-3 pt-3 pb-5 text-deep-blue dark:text-slate-300 font-sans font-medium">
                © {{new Date().getFullYear()}} Anykod
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
